import React from 'react';
import { PieChart, LineChart, BarChart, Pie, Cell, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Bar } from 'recharts';
import { Box, Grid, Paper, Typography, Card } from '@mui/material';

const InsightsDashboard = ({ inquiries }) => {
  // Calculate data for charts
  const genderData = [
    { name: 'Male', value: inquiries?.filter((inquiry) => inquiry.gender === 'male').length },
    { name: 'Female', value: inquiries?.filter((inquiry) => inquiry.gender === 'female').length },
  ];

  const paymentStatusData = [
    { name: 'Paid', value: inquiries?.filter((inquiry) => inquiry.paymentStatus === 'paid').length },
    { name: 'Not Paid', value: inquiries?.filter((inquiry) => inquiry.paymentStatus === 'unpaid').length },
  ];

  const paymentMethod = [
    { name: 'OTC', value: inquiries?.filter((inquiry) => inquiry.paymentMethod === 'Over The Counter').length },
    { name: 'Bank Transfer', value: inquiries?.filter((inquiry) => inquiry.paymentMethod === 'Bank Transfer Online').length },
    { name: 'CDM', value: inquiries?.filter((inquiry) => inquiry.paymentMethod === 'CDM').length },
    { name: 'POS', value: inquiries?.filter((inquiry) => inquiry.paymentMethod === 'POS').length },
  ];



  const countryData = inquiries?.reduce((acc, inquiry) => {
    if (inquiry.country in acc) {
      acc[inquiry.country]++;
    } else {
      acc[inquiry.country] = 1;
    }
    return acc;
  }, {});

  var countryChartData = '';

  if (countryData != null) {
    countryChartData = Object.entries(countryData).map(([country, count]) => ({ country, count }));
  }

  const jobData = inquiries?.reduce((acc, inquiry) => {
    const job = inquiry.appliedPosition1;
    if (job in acc) {
      acc[job]++;
    } else {
      acc[job] = 1;
    }
    return acc;
  }, {});

  const jobChartData = Object.entries(jobData || {}).map(([job, count]) => ({ job, count }));

  const last7Days = new Array(7)
    .fill(0)
    .map((_, index) => {
      const date = new Date();
      date.setDate(date.getDate() - index);
      return date.toLocaleDateString();
    })
    .reverse();

    const dailyInquiryData = last7Days.map((date) => {
        const formattedDate = new Date(date).toISOString().split('T')[0];
        console.log(formattedDate)
        console.log(inquiries)
        const count = inquiries?.filter((inquiry) =>  inquiry.createdAt.split('T')[0]=== formattedDate ).length || 0;
        return { date, count };
    });
      

  const renderPieChart = (
    <PieChart width={300} height={300}>
      <Pie data={genderData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
      <Cell fill="#FF6384" />
        <Cell fill="#36A2EB" />
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  );

  const renderPieChartPayment = (
    <PieChart width={300} height={300}>
      <Pie data={paymentStatusData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
      <Cell fill="#28ECE0" />
        <Cell fill="#28EC28 " />
       
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  );

  const renderPieChartPaymentMethod = (
    <PieChart width={300} height={300}>
      <Pie data={paymentMethod} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
      <Cell fill="#FF5733" /> {/* Orange */}
      <Cell fill="#4CAF50" /> {/* Green */}
      <Cell fill="#4287F5" /> {/* Blue */}
      <Cell fill="#F5428D" /> {/* Pink */}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  );

  const renderLineChart = (
    <LineChart width={600} height={300} data={countryChartData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="country" />
      <YAxis />
      <Tooltip />
      <Line type="monotone" dataKey="count" stroke="#8884d8" />
    </LineChart>
  );

  const renderBarChartJobs = (
    <BarChart width={800} height={300} data={jobChartData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="job" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="count" fill="#FF6384" />
    </BarChart>
  );

  const renderBarChartDailyInquiries = (
    <BarChart width={800} height={300} data={dailyInquiryData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="count" fill="#FF6384" />
    </BarChart>
  );

  return (
    <div>
      <Grid container spacing={2} direction="row" sx={{ pt: '4px' }}>
        <Grid item xs={4}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
            <h3>Gender Distribution</h3>
            </div>
            {renderPieChart}
          </Card>
        </Grid>
        <Grid item xs={4}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
            <h3>Payment Status</h3>
            </div>
            {renderPieChartPayment}
          </Card>
        </Grid>
        <Grid item xs={4}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
            <h3>Payment Methods</h3>
            </div>
            {renderPieChartPaymentMethod}
          </Card>
        </Grid>
        <Grid item xs={12}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
            <h3>Registrations by Country</h3>
            </div>
            {renderLineChart}
          </Card>
        </Grid>
        <Grid item xs={12}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
          <div style={{ textAlign: 'center' }}>
            <h3>Registrations by applied positions </h3>
            </div>
            {renderBarChartJobs}
          </Card>
        </Grid>
        <Grid item xs={12}>
        <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 0px 4px rgba(0, 0, 0, 0.2)' }}>
          <div style={{ textAlign: 'center' }}>
            <h3>Daily Registration Count (Last 7 Days)</h3>
            </div>
            {renderBarChartDailyInquiries}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default InsightsDashboard;
